import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M17 15h2V5H9v2h8v8zM7 17V1H5v4H1v2h4v12h12v4h2v-4h4v-2H7z"
}), 'CropSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/CropSharp.js
// module id = 3036
// module chunks = 2